import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";
const FlowTypeModal = ({ isOpen, onClose, onSave }) => {
  const [keywords, setKeywords] = useState("");
  const handleSave = () => {
    onSave(keywords);
    onClose();
  };
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 700,
        }}
      >
        Edit Keywords
        <IconButton onClick={onClose}>
          <AiOutlineClose />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ bgcolor: "#F9FAFB" }}>
        <TextField
          label="Keywords"
          placeholder="Enter keywords (comma separated)"
          fullWidth
          value={keywords}
          onChange={(e) => setKeywords(e.target.value)}
          size="small"
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{
            bgcolor: "#25D366",
            textTransform: "none",
            "&:hover": { bgcolor: "#22C35E" },
          }}
          onClick={handleSave}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default FlowTypeModal;
